<ng-template #content let-modal>
  <div trapFocus style="overflow-y: auto">
    <div class="modal-header ml-auto align-items-center">
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="startSimulation()"
        ngbAutofocus
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body p-3 validate-lb" id="lightbox" style="height: 75vh">
      <div
        class="row"
        style="
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 80%;
          height: 80%;
        "
      >
        <div class="col-12">
          <div class="h2-eq" style="text-align: center" *ngIf="viewIndex === 0">
            <h2>{{ data?.page1TitleText }}</h2>

            <h3 style="margin-top: 50px; margin-bottom: 50px">
              {{ data?.page1SubTitleText }}
            </h3>

            <button
              *ngFor="let itm of data?.languageChoices"
              class="btn-validate text-uppercase"
              (click)="selectLanguage(itm.language)"
            >
              {{ itm.caption }}
            </button>
          </div>

          <div style="text-align: center" *ngIf="viewIndex === 1">
            <h2>{{ selectedLanguageTexts?.page2TitleText }}</h2>

            <div class="video-container">
              <iframe
                style="margin-top: 50px; margin-bottom: 50px"
                width="853"
                height="480"
                [src]="selectedLanguageTexts?.page2VideoLink | safe"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div class="h2-eq" style="text-align: center">
              <button
                class="btn-validate text-uppercase"
                (click)="goToLastView()"
              >
                {{ selectedLanguageTexts?.page2ButtonText }}
              </button>
            </div>
          </div>

          <div style="text-align: center" *ngIf="viewIndex === 2">
            <h2>{{ selectedLanguageTexts?.page3TitleText }}</h2>

            <div class="video-container">
              <video autoplay>
                <source src="img/documents.mp4" type="video/mp4" />
              </video>
            </div>
            <div class="h2-eq" style="text-align: center">
              <button
                class="btn-validate text-uppercase"
                (click)="startSimulation()"
              >
                {{ selectedLanguageTexts?.page3ButtonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer text-uppercase"></div>
  </div>
</ng-template>
